import type { ConceptDef } from '../types';

export const tactActions: ConceptDef = {
  kind: 'supervisorScored',
  id: 'tact-actions',
  label: 'Expressive Actions',
  category: 'Expressive',
  description: 'Show an action picture; learner names it. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: '🏃 running' },
      { prompt: '😴 sleeping' },
      { prompt: '🏊 swimming' },
      { prompt: '🤸 jumping' },
      { prompt: '🍽 eating' },
      { prompt: '💃 dancing' },
    ],
  },
};
